import videojs from "video.js";
import { initNextVideoBar, nextVideo } from "./nextVideoComponent";
import { initQuality, quality } from "./qualityComponent";
import { initMenuFunctional } from "./videoMenu";
import { initTimeCodes } from "./timeCodes";
import { initTimeBanners, timeBanners } from "./timeBannersComponent";
import { sendStats } from "./sendStats";
import { checkCurrentTime } from "./checkCurrentTime";
import "videojs-hotkeys";
import { initSharing } from "./sharing";
import baron from "baron";
import { playListMove } from "./playListMove";
import { initAdvertisement, advertisementLink, advertisementMarks} from "./advertisement";

export const initPlayer = () => {
	const videos = document.querySelectorAll( 'video.video-player' );
	
	if ( !videos.length )
	{
		return;
	}
	
	videos.forEach( (video) => {
		videojs.registerComponent('quality', quality);
		videojs.registerComponent('nextVideo', nextVideo);
		videojs.registerComponent('timeBanners', timeBanners);
		videojs.registerComponent('advertisementLink', advertisementLink);
		videojs.registerComponent('advertisementMarks', advertisementMarks);

		const section = video.closest( 'section' );
		
		if ( section && window.innerWidth > 575 ) {
			baron({
				root: '.scroll-container',
				scroller: '.scroll-content',
				bar: '.scroll-bar',
				barOnCls: '.scroll-bar-on'
			});
		}	

		const player = videojs('video-player', {
			inactivityTimeout: 1000,
			controls: true,
			controlBar: {
				volumePanel: {
					inline: false
				},
			},
			menu: {
				children: [ 'PlaybackRateMenuButton' ],
			},
			
			html5: {
				vhs: {
					overrideNative: true,	
				},
			},
			preload: false,
			bigPlayButton: false,
			responsive: true,
			playbackRates: [0.5, 1, 1.5, 2],
		});

		if ( window.innerWidth < 769 ) {
			player.options().inactivityTimeout = 7000;
		}
		
		player.ready(function() {
			if ( section ) {
				var promise = player.play();
				player.playsinline(true);
				if (promise !== undefined) {
				  promise.then(function() {
				  }).catch(function() {
					player.volume(0);
					player.play();
				  });
				}
				setTimeout(() => {
					player.play();
				}, 50);
			}
			
			this.hotkeys({
				volumeStep: 0.1,
				seekStep: 5,
				enableMute: true,
				enableFullscreen: true,
				enableNumbers: false,
				enableVolumeScroll: true,
				enableHoverScroll: true,
				captureDocumentHotkeys: true,
				documentHotkeysFocusElementFilter: e => e.tagName.toLowerCase() === "body",
			})	
		  });
		  
		  player.addChild('button', {
			controlText: 'play',
			className: 'play-button-mobile',
			clickHandler: function(event) {
				player.paused() ? player.play() : player.pause();
			}
		});
	
		if ( section && !section.classList.contains( 'video' ) && section.querySelector( 'ul.picture-time-codes' ) ) {
			player.getChild('ControlBar').addChild('button', {
				controlText: 'Эпизоды',
				className: 'time-codes',
				clickHandler: function(event) {
					this.el_.classList.toggle( 'active' );
					section.querySelector( 'ul.picture-time-codes' ).classList.toggle( 'active' );
				}
			});
		}

		if ( !section ) {

			document.querySelector( 'picture.poster' )?.addEventListener( 'click', () => {
				player.play();
			} )	
			
			player.getChild('ControlBar').el_.classList.add( 'embed' );
			player.getChild('ControlBar').addChild('button', {
				controlText: 'Посмотреть на cdsvideo',
				className: 'link',
				clickHandler: function(event) {
					window.open(`https://cdsvideo.ru/video/${video.getAttribute('data-video-id')}/`);
				}
			});
		}

		player.getChild('menu').addChild('quality');

		initMenuFunctional(player);
		initQuality(player);
		checkCurrentTime(player);
		
		if ( section ) {
			initSharing(player, section);
			initTimeCodes(player, section);
			initNextVideoBar(player, section);
			initTimeBanners(player, section);
			sendStats(player, section.getAttribute('video-id'));	
			playListMove(section);
			initAdvertisement(player, section);
		}
	} )
};